// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1n1vZ","label":"styles_label__eXCqf"};